import getLink from '@bottlebooks/gatsby-theme-event/src/getLink';

export default function getUrlFromPageReference(pageReference) {
  if (!pageReference) return null;
  const link = getLink();
  switch (pageReference.__typename) {
    case 'Page':
    case 'SanityPage':
      return `/${pageReference?.slug?.current}`;
    case 'ExternalPage':
    case 'SanityExternalPage':
      return pageReference.url;
    case 'BottlebooksPage':
    case 'SanityBottlebooksPage':
      // Not sure why context isn't available
      // return link[pageReference.type]?.();
      return `/${pageReference.type}`;
    default:
      return null;
  }
}
